export function GymComingSoonPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Gym</h1>
          <p className="page-sub">More coming soon.</p>
        </div>
      </header>
    </div>
  );
}
